import React, { useState, useEffect,useCallback } from 'react';
import {
    Icon,
    Button,
    Label,
} from 'semantic-ui-react'

export default function CopyField({val}) {
    const [copied, setCopied] = useState(0);
	const copyToClipboard = useCallback(() => {
        navigator.clipboard.writeText(val).then(() => {
            setCopied(Date.now());
        });
    }, [val]);
	useEffect(() => {
        if (copied) {
            const id = setTimeout(() => {
                setCopied(0);
            }, 2000);

            return () => clearTimeout(id);
        }
    }, [copied]);


	return <Button as='div' labelPosition='right' size='tiny' style={{marginTop:'.5em'}}
				onClick={()=>{
					copyToClipboard()
					// window.current = ref.current
					// ref.current.select();
					// document.execCommand("copy");
				}}
			>
		<Button icon  size='tiny'>
		<Icon name={copied ? 'check' : 'clipboard'} />
		</Button>
		<Label as='a' basic pointing='left'>
			{val}
		</Label>
	</Button>
}